<template>
	<div class="card">
		<div class="card-header">
			Mesin Presensi
			<el-tooltip placement="right" content="Kelola mesin presensi">
				<el-button link type="primary" tag="router-link" to="mesin">
					<el-icon><i class="bi bi-box-arrow-in-up-right"></i></el-icon>
				</el-button>
			</el-tooltip>
		</div>
		<div class="card-body d-flex justify-content-center" v-loading="loading">
			<div class="hstack gap-1">
				<transition name="slide-up" mode="out-in">
					<span :key="jumlah" class="fs-5">{{ jumlah || "-" }}</span>
				</transition>
				<span>mesin aktif</span>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "MesinPresensi",
	data() {
		return {
			jumlah: 0,
			loading: true,
		};
	},
	mounted() {
		this.$ws.main.on("mesin:inserted", this.insertedMesin);
		this.$ws.main.on("mesin:updated", this.updatedMesin);
		this.$ws.main.on("mesin:deleted", this.deletedMesin);
		this.getJumlahMesinPresensi();
	},
	beforeUnmount() {
		this.$ws.main.off("mesin:inserted");
		this.$ws.main.off("mesin:updated");
		this.$ws.main.off("mesin:deleted");
	},
	methods: {
		insertedMesin() {
			this.jumlah++;
		},
		updatedMesin(data) {
			const d = JSON.parse(data);

			if (d.aktif === 1) this.jumlah++;
			if (d.aktif === 0) this.jumlah--;
		},
		deletedMesin() {
			this.jumlah--;
		},
		async getJumlahMesinPresensi() {
			try {
				const { data } = await this.$defaultApi.post("/mesin/count");

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.jumlah = data.jumlah_mesin;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.error(error);
			} finally {
				this.loading = false;
			}
		},
	},
};
</script>

<style scoped></style>
